import { NgModule } from '@angular/core';
import { BlockGroupComponent } from './component/group/group';
import { BuildContentComponent } from './component/build-content/build-content';
import { StepContentElementDirective } from './directive/step-content-element';

@NgModule({
  declarations: [BlockGroupComponent, BuildContentComponent, StepContentElementDirective],
  exports: [BlockGroupComponent, BuildContentComponent, StepContentElementDirective],
})
export class BlockSharedModule {}
